module.exports = __webpack_public_path__ + "img/7.35bf637f.jpg";